/**
 *证件种类
 */
export const zjzlList = [
  {"value": "00", "label": "无证件"},
  {"value": "05", "label": "往来台湾通行证（一次有效）"},
  {"value": "06", "label": "台湾居民来往大陆通行证（一次有效）"},
  {"value": "07", "label": "台湾居民居住证"},
  {"value": "08", "label": "港澳居民居住证"},
  {"value": "0A", "label": "非税票据"},
  {"value": "0B", "label": "回乡证白卡"},
  {"value": "10", "label": "身份证"},
  {"value": "11", "label": "外交护照"},
  {"value": "12", "label": "公务护照"},
  {"value": "13", "label": "因公普通护照"},
  {"value": "14", "label": "普通护照"},
  {"value": "15", "label": "中华人民共和国旅行证"},
  {"value": "16", "label": "台湾居民来往大陆通行证（五年有效）"},
  {"value": "17", "label": "海员证"},
  {"value": "20", "label": "中华人民共和国出入境通行证"},
  {"value": "21", "label": "往来港澳通行证"},
  {"value": "23", "label": "前往港澳通行证"},
  {"value": "24", "label": "港澳居民来往内地通行证"},
  {"value": "25", "label": "往来台湾通行证"},
  {"value": "27", "label": "港澳居民定居证"},
  {"value": "28", "label": "华侨回国定居证"},
  {"value": "29", "label": "台湾居民定居证"},
  {"value": "2F", "label": "中华人民共和国出入境通行证（边境旅游专用）"},
  {"value": "30", "label": "外国人出入境证"},
  {"value": "31", "label": "外国人旅行证"},
  {"value": "32", "label": "外国人居留证、居留许可"},
  {"value": "33", "label": "外国人临时居留证"},
  {"value": "34", "label": "外国人永久居留身份证"},
  {"value": "35", "label": "入籍证书"},
  {"value": "36", "label": "出籍证书"},
  {"value": "37", "label": "复籍证书"},
  {"value": "3E", "label": "特区旅游签证"},
  {"value": "3P", "label": "普通签证"},
  {"value": "3T", "label": "团体签证"},
  {"value": "49", "label": "台湾居民登陆证"},
  {"value": "51", "label": "签证身份书"},
  {"value": "60", "label": "边境通行证"},
  {"value": "66", "label": "回美证"},
  {"value": "70", "label": "香港特别行政区护照"},
  {"value": "71", "label": "澳门特别行政区护照"},
  {"value": "72", "label": "因公往来港澳通行证（高官证）"},
  {"value": "73", "label": "因公往来港澳通行证（普通证）"},
  {"value": "74", "label": "港澳台贴纸签注"},
  {"value": "75", "label": "大陆证贴纸签注"},
  {"value": "76", "label": "台湾居民居留贴纸签注"},
  {"value": "77", "label": "台湾居民来往贴纸签注"},
  {"value": "78", "label": "贴纸加注"},
  {"value": "98", "label": "转印膜"},
  {"value": "99", "label": "其它证件"},
  {"value": "9A", "label": "电子护照塑封膜"},
  {"value": "9B", "label": "退籍证书"},
  {"value": "9D", "label": "卡式证件防伪膜"},
  {"value": "9E", "label": "2014版塑封膜"},
  {"value": "9F", "label": "电子台胞证塑封膜"},
]

export const rydlList = [
  {"value": "C", "label": "华侨"},
  {"value": "E", "label": "港澳居民"},
  {"value": "F", "label": "外国人"},
  {"value": "H", "label": "香港居民"},
  {"value": "M", "label": "澳门居民"},
  {"value": "O", "label": "外籍华人"},
  {"value": "R", "label": "内地居民"},
  {"value": "T", "label": "台湾居民"},
]

export const NCitiList = [
  {"value": "ABW", "label": "阿鲁巴"},
  {"value": "AFG", "label": "阿富汗"},
  {"value": "AGO", "label": "安哥拉"},
  {"value": "AIA", "label": "安圭拉"},
  {"value": "ALA", "label": "奥兰群岛"},
  {"value": "ALB", "label": "阿尔巴尼亚"},
  {"value": "AND", "label": "安道尔"},
  {"value": "ANT", "label": "荷属安的列斯"},
  {"value": "ARE", "label": "阿联酋"},
  {"value": "ARG", "label": "阿根廷"},
  {"value": "ARM", "label": "亚美尼亚"},
  {"value": "ASM", "label": "美属萨摩亚"},
  {"value": "ATA", "label": "南极洲"},
  {"value": "ATF", "label": "法属南领地"},
  {"value": "ATG", "label": "安提瓜和巴布达"},
  {"value": "AUS", "label": "澳大利亚"},
  {"value": "AUT", "label": "奥地利"},
  {"value": "AZE", "label": "阿塞拜疆"},
  {"value": "BDI", "label": "布隆迪"},
  {"value": "BEL", "label": "比利时"},
  {"value": "BEN", "label": "贝宁"},
  {"value": "BES", "label": "博内尔岛、圣尤斯特歇斯岛和萨巴岛"},
  {"value": "BFA", "label": "布基纳法索"},
  {"value": "BGD", "label": "孟加拉国"},
  {"value": "BGR", "label": "保加利亚"},
  {"value": "BHR", "label": "巴林"},
  {"value": "BHS", "label": "巴哈马"},
  {"value": "BIH", "label": "波黑"},
  {"value": "BLM", "label": "圣巴泰勒米岛"},
  {"value": "BLR", "label": "白俄罗斯"},
  {"value": "BLZ", "label": "伯利兹"},
  {"value": "BMU", "label": "百慕大"},
  {"value": "BOL", "label": "玻利维亚"},
  {"value": "BRA", "label": "巴西"},
  {"value": "BRB", "label": "巴巴多斯"},
  {"value": "BRN", "label": "文莱"},
  {"value": "BTN", "label": "不丹"},
  {"value": "BVT", "label": "布维岛"},
  {"value": "BWA", "label": "博茨瓦纳"},
  {"value": "CAF", "label": "中非"},
  {"value": "CAN", "label": "加拿大"},
  {"value": "CCK", "label": "科科斯（基灵）群岛"},
  {"value": "CHE", "label": "瑞士"},
  {"value": "CHL", "label": "智利"},
  {"value": "CHN", "label": "中国"},
  {"value": "CIV", "label": "科特迪瓦"},
  {"value": "CMR", "label": "喀麦隆"},
  {"value": "COD", "label": "刚果(金)"},
  {"value": "COG", "label": "刚果(布)"},
  {"value": "COK", "label": "库克群岛"},
  {"value": "COL", "label": "哥伦比亚"},
  {"value": "COM", "label": "科摩罗"},
  {"value": "CPV", "label": "佛得角"},
  {"value": "CRI", "label": "哥斯达黎加"},
  {"value": "CUB", "label": "古巴"},
  {"value": "CUW", "label": "库拉索"},
  {"value": "CXR", "label": "圣诞岛"},
  {"value": "CYM", "label": "开曼群岛"},
  {"value": "CYP", "label": "塞浦路斯"},
  {"value": "CZE", "label": "捷克"},
  {"value": "DEU", "label": "德国"},
  {"value": "DJI", "label": "吉布提"},
  {"value": "DMA", "label": "多米尼克"},
  {"value": "DNK", "label": "丹麦"},
  {"value": "DOM", "label": "多米尼加"},
  {"value": "DZA", "label": "阿尔及利亚"},
  {"value": "ECU", "label": "厄瓜多尔"},
  {"value": "EGY", "label": "埃及"},
  {"value": "ERI", "label": "厄立特里亚"},
  {"value": "ESH", "label": "西撒哈拉"},
  {"value": "ESP", "label": "西班牙"},
  {"value": "EST", "label": "爱沙尼亚"},
  {"value": "ETH", "label": "埃塞俄比亚"},
  {"value": "FIN", "label": "芬兰"},
  {"value": "FJI", "label": "斐济"},
  {"value": "FLK", "label": "福克兰群岛（马尔维纳斯）"},
  {"value": "FRA", "label": "法国"},
  {"value": "FRO", "label": "法罗群岛"},
  {"value": "FSM", "label": "密克罗尼西亚联邦"},
  {"value": "GAB", "label": "加蓬"},
  {"value": "GBD", "label": "英国（属地公民）"},
  {"value": "GBN", "label": "英国（国民（海外））"},
  {"value": "GBO", "label": "英国（海外公民）"},
  {"value": "GBP", "label": "英国（被保护人）"},
  {"value": "GBR", "label": "英国"},
  {"value": "GBS", "label": "英国（臣民）"},
  {"value": "GEO", "label": "格鲁吉亚"},
  {"value": "GGY", "label": "根西岛"},
  {"value": "GHA", "label": "加纳"},
  {"value": "GIB", "label": "直布罗陀"},
  {"value": "GIN", "label": "几内亚"},
  {"value": "GLP", "label": "瓜德罗普"},
  {"value": "GMB", "label": "冈比亚"},
  {"value": "GNB", "label": "几内亚比绍"},
  {"value": "GNQ", "label": "赤道几内亚"},
  {"value": "GRC", "label": "希腊"},
  {"value": "GRD", "label": "格林纳达"},
  {"value": "GRL", "label": "格陵兰"},
  {"value": "GTM", "label": "危地马拉"},
  {"value": "GUF", "label": "法属圭亚那"},
  {"value": "GUM", "label": "关岛"},
  {"value": "GUY", "label": "圭亚那"},
  {"value": "HKG", "label": "中国香港"},
  {"value": "HMD", "label": "赫德岛和麦克唐纳群岛"},
  {"value": "HND", "label": "洪都拉斯"},
  {"value": "HRV", "label": "克罗地亚"},
  {"value": "HTI", "label": "海地"},
  {"value": "HUN", "label": "匈牙利"},
  {"value": "IDN", "label": "印度尼西亚"},
  {"value": "IMN", "label": "马恩岛"},
  {"value": "IND", "label": "印度"},
  {"value": "IOT", "label": "英属印度洋领地"},
  {"value": "IRL", "label": "爱尔兰"},
  {"value": "IRN", "label": "伊朗"},
  {"value": "IRQ", "label": "伊拉克"},
  {"value": "ISL", "label": "冰岛"},
  {"value": "ISR", "label": "以色列"},
  {"value": "ITA", "label": "意大利"},
  {"value": "JAM", "label": "牙买加"},
  {"value": "JEY", "label": "泽西"},
  {"value": "JOR", "label": "约旦"},
  {"value": "JPN", "label": "日本"},
  {"value": "JTN", "label": "约翰斯顿岛"},
  {"value": "KAZ", "label": "哈萨克斯坦"},
  {"value": "KEN", "label": "肯尼亚"},
  {"value": "KGZ", "label": "吉尔吉斯斯坦"},
  {"value": "KHM", "label": "柬埔寨"},
  {"value": "KIR", "label": "基里巴斯"},
  {"value": "KNA", "label": "圣基茨和尼维斯"},
  {"value": "KOR", "label": "韩国"},
  {"value": "KWT", "label": "科威特"},
  {"value": "LAO", "label": "老挝"},
  {"value": "LBN", "label": "黎巴嫩"},
  {"value": "LBR", "label": "利比里亚"},
  {"value": "LBY", "label": "利比亚"},
  {"value": "LCA", "label": "圣卢西亚"},
  {"value": "LIE", "label": "列支敦士登"},
  {"value": "LKA", "label": "斯里兰卡"},
  {"value": "LSO", "label": "莱索托"},
  {"value": "LTU", "label": "立陶宛"},
  {"value": "LUX", "label": "卢森堡"},
  {"value": "LVA", "label": "拉脱维亚"},
  {"value": "MAC", "label": "中国澳门"},
  {"value": "MAF", "label": "圣马丁岛（法属）"},
  {"value": "MAR", "label": "摩洛哥"},
  {"value": "MCO", "label": "摩纳哥"},
  {"value": "MDA", "label": "摩尔多瓦"},
  {"value": "MDG", "label": "马达加斯加"},
  {"value": "MDV", "label": "马尔代夫"},
  {"value": "MEX", "label": "墨西哥"},
  {"value": "MHL", "label": "马绍尔群岛"},
  {"value": "MID", "label": "中途岛"},
  {"value": "MKD", "label": "北马其顿"},
  {"value": "MLI", "label": "马里"},
  {"value": "MLT", "label": "马耳他"},
  {"value": "MMR", "label": "缅甸"},
  {"value": "MNE", "label": "黑山"},
  {"value": "MNG", "label": "蒙古"},
  {"value": "MNP", "label": "北马里亚纳群岛"},
  {"value": "MOZ", "label": "莫桑比克"},
  {"value": "MRT", "label": "毛里塔尼亚"},
  {"value": "MSR", "label": "蒙特塞拉特"},
  {"value": "MTQ", "label": "马提尼克"},
  {"value": "MUS", "label": "毛里求斯"},
  {"value": "MWI", "label": "马拉维"},
  {"value": "MYS", "label": "马来西亚"},
  {"value": "MYT", "label": "马约特"},
  {"value": "NAM", "label": "纳米比亚"},
  {"value": "NCL", "label": "新喀里多尼亚"},
  {"value": "NER", "label": "尼日尔"},
  {"value": "NFK", "label": "诺福克岛"},
  {"value": "NGA", "label": "尼日利亚"},
  {"value": "NIC", "label": "尼加拉瓜"},
  {"value": "NIU", "label": "纽埃"},
  {"value": "NLD", "label": "荷兰"},
  {"value": "NOR", "label": "挪威"},
  {"value": "NPL", "label": "尼泊尔"},
  {"value": "NRU", "label": "瑙鲁"},
  {"value": "NTZ", "label": "中立区"},
  {"value": "NZL", "label": "新西兰"},
  {"value": "OMN", "label": "阿曼"},
  {"value": "PAK", "label": "巴基斯坦"},
  {"value": "PAN", "label": "巴拿马"},
  {"value": "PCN", "label": "皮特凯恩"},
  {"value": "PER", "label": "秘鲁"},
  {"value": "PHL", "label": "菲律宾"},
  {"value": "PLW", "label": "帕劳"},
  {"value": "PNG", "label": "巴布亚新几内亚"},
  {"value": "POL", "label": "波兰"},
  {"value": "PRI", "label": "波多黎各"},
  {"value": "PRK", "label": "朝鲜"},
  {"value": "PRT", "label": "葡萄牙"},
  {"value": "PRY", "label": "巴拉圭"},
  {"value": "PSE", "label": "巴勒斯坦"},
  {"value": "PUS", "label": "美属太平洋群岛"},
  {"value": "PYF", "label": "法属波利尼西亚"},
  {"value": "QAT", "label": "卡塔尔"},
  {"value": "REU", "label": "留尼汪岛"},
  {"value": "ROU", "label": "罗马尼亚"},
  {"value": "RUS", "label": "俄罗斯"},
  {"value": "RWA", "label": "卢旺达"},
  {"value": "SAU", "label": "沙特"},
  {"value": "SDN", "label": "苏丹"},
  {"value": "SEN", "label": "塞内加尔"},
  {"value": "SGP", "label": "新加坡"},
  {"value": "SGS", "label": "南乔治亚和南桑威奇群岛"},
  {"value": "SHN", "label": "圣赫勒拿岛、阿森松岛和特里斯坦达库尼亚群岛"},
  {"value": "SJM", "label": "斯瓦尔巴和扬马延群岛"},
  {"value": "SLB", "label": "所罗门群岛"},
  {"value": "SLE", "label": "塞拉利昂"},
  {"value": "SLV", "label": "萨尔瓦多"},
  {"value": "SMR", "label": "圣马力诺"},
  {"value": "SOM", "label": "索马里"},
  {"value": "SPM", "label": "圣皮埃尔和密克隆"},
  {"value": "SRB", "label": "塞尔维亚"},
  {"value": "SSD", "label": "南苏丹"},
  {"value": "STP", "label": "圣多美和普林西比"},
  {"value": "SUR", "label": "苏里南"},
  {"value": "SVK", "label": "斯洛伐克"},
  {"value": "SVN", "label": "斯洛文尼亚"},
  {"value": "SWE", "label": "瑞典"},
  {"value": "SWZ", "label": "斯威士兰"},
  {"value": "SXM", "label": "圣马丁岛（荷属）"},
  {"value": "SYC", "label": "塞舌尔"},
  {"value": "SYR", "label": "叙利亚"},
  {"value": "TCA", "label": "特克斯和凯科斯群岛"},
  {"value": "TCD", "label": "乍得"},
  {"value": "TGO", "label": "多哥"},
  {"value": "THA", "label": "泰国"},
  {"value": "TJK", "label": "塔吉克斯坦"},
  {"value": "TKL", "label": "托克劳群岛"},
  {"value": "TKM", "label": "土库曼斯坦"},
  {"value": "TLS", "label": "东帝汶"},
  {"value": "TON", "label": "汤加"},
  {"value": "TTO", "label": "特立尼达和多巴哥"},
  {"value": "TUN", "label": "突尼斯"},
  {"value": "TUR", "label": "土耳其"},
  {"value": "TUV", "label": "图瓦卢"},
  {"value": "TWN", "label": "中国台湾"},
  {"value": "TZA", "label": "坦桑尼亚"},
  {"value": "UGA", "label": "乌干达"},
  {"value": "UKR", "label": "乌克兰"},
  {"value": "UMI", "label": "美国本土外小岛屿"},
  {"value": "UNA", "label": "联合国"},
  {"value": "UNO", "label": "联合国"},
  {"value": "URY", "label": "乌拉圭"},
  {"value": "USA", "label": "美国"},
  {"value": "UZB", "label": "乌兹别克斯坦"},
  {"value": "VAT", "label": "梵蒂冈"},
  {"value": "VCT", "label": "圣文森特和格林纳丁斯"},
  {"value": "VEN", "label": "委内瑞拉"},
  {"value": "VGB", "label": "维尔京群岛（英属）"},
  {"value": "VIR", "label": "维尔京群岛（美属）"},
  {"value": "VNM", "label": "越南"},
  {"value": "VUT", "label": "瓦努阿图"},
  {"value": "WAK", "label": "威克岛"},
  {"value": "WLF", "label": "瓦利斯和富图纳群岛"},
  {"value": "WSM", "label": "萨摩亚"},
  {"value": "XXA", "label": "无国籍（无国籍人）"},
  {"value": "XXB", "label": "被联合国承认的难民"},
  {"value": "XXC", "label": "不被联合国承认的难民"},
  {"value": "XXX", "label": "国籍不明"},
  {"value": "YEM", "label": "也门"},
  {"value": "YKS", "label": "科索沃"},
  {"value": "ZAF", "label": "南非"},
  {"value": "ZMB", "label": "赞比亚"},
  {"value": "ZWE", "label": "津巴布韦"},
  {"value": "ZZZ", "label": "国籍不详"},

]
